import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';

import { verifyGymEmail } from '../api';


const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [result, setResult] = useState({
    status: 'loading',
    message: 'Vérification du lien en cours…'
  });

  useEffect(() => {
    let active = true;

    const verify = async () => {
      if (!token) {
        setResult({
          status: 'error',
          message: 'Le lien de confirmation est incomplet.',
        });
        return;
      }

      try {
        const response = await verifyGymEmail(token);
        if (active) {
          setResult({
            status: 'success',
            message: response.message,
          });
        }
      } catch (error) {
        if (active) {
          setResult({
            status: 'error',
            message: error.message || "L'adresse e-mail n'a pas pu être confirmée.",
          });
        }
      }
    };

    verify();

    return () => {
      active = false;
    };
  }, [token]);

  const loading = result.status === 'loading';
  const success = result.status === 'success';

  return (
    <Box
      dir="ltr"
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        bgcolor: '#eef2f6',
        p: 3,
      }}
    >
      <Card
        elevation={0}
        sx={{
          width: 'min(100%, 520px)',
          borderRadius: 5,
          boxShadow: '0 16px 50px rgba(1, 4, 73, 0.12)',
        }}
      >
        <CardContent sx={{ p: { xs: 4, sm: 5 }, textAlign: 'center' }}>
          <Box
            sx={{
              width: 76,
              height: 76,
              display: 'grid',
              placeItems: 'center',
              mx: 'auto',
              mb: 3,
              borderRadius: '50%',
              bgcolor: loading ? '#eef2ff' : success ? '#e8f7ee' : '#fff0f0',
              color: loading ? '#010449' : success ? '#16854a' : '#c62828',
              fontSize: 40,
              fontWeight: 700,
            }}
          >
            {loading ? <CircularProgress size={38} color="inherit" /> : success ? '✓' : '×'}
          </Box>

          <Typography variant="h5" fontWeight={700} color="#010449">
            {loading
              ? "Confirmation de l'adresse e-mail"
              : success
                ? 'Adresse e-mail confirmée'
                : 'Confirmation impossible'}
          </Typography>

          <Typography color="text.secondary" sx={{ mt: 2, lineHeight: 2 }}>
            {result.message}
          </Typography>

          {!loading && (
            <Button
              component={Link}
              to="/"
              variant="contained"
              sx={{
                mt: 4,
                px: 4,
                py: 1.2,
                borderRadius: 3,
                bgcolor: '#010449',
                '&:hover': { bgcolor: '#02066f' },
              }}
            >
              Revenir à Gyma
            </Button>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default VerifyEmail;
